<script>

    import { toast } from 'bulma-toast'
    import { AccountStore } from '../stores'

    import AccountsService from '../$services/accounts.service'
    
    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Value from '../$components/value.svelte'

    let loading = false
    let total = null

    getAccountTotal()

    async function getAccountTotal() {

        loading = true
        const resp = await AccountsService.getAccountTotal($AccountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        total = resp.data
    }

</script>


{#if $AccountStore}
    <div class="columns">
        <div class="column">
            <Value label="Estatus" value={ DateMethods.isAfter($AccountStore.expired)? 'Activo' : 'Expiró' } />
        </div>
        <div class="column">
            <Value label="Limite" value={ $AccountStore.limit? NumeralMethods.cash($AccountStore.limit) : 'Sin limite' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Ciclo" value={ EnumMethods.get($AccountStore.cycleType) } />
        </div>
        {#if $AccountStore.cycleType === 'weekly'}
            <div class="column">
                <Value label="Día de la semana" value={ EnumMethods.get($AccountStore.cycleDay) } />
            </div>
        {/if}
        {#if $AccountStore.cycleType === 'monthDays'}
        <div class="column">
            <Value label="Días del mes" value={ $AccountStore.monthDays } />
        </div>
    {/if}
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Envíos" value={ $AccountStore.shipments.length } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Cargos" value={ $AccountStore.charges.length } />
        </div>
        <div class="column">
            <Value label="Reembolsos" value={ $AccountStore.refunds.length } />
        </div>
    </div>
    {#if $AccountStore.payment === 'paid'}
        <div class="columns">
            <div class="column">
                <Value label="Fecha de pago" value={ DateMethods.dateTimeLarge($AccountStore.payment) } />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Value label="Referencia de pago" value={ $AccountStore.reference || 'Sin referencia' } />
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column">
            <Value label="Fecha de inicio" value={ DateMethods.dateTimeLarge($AccountStore.activated) } />
        </div>
        <div class="column">
            <Value label="Fecha de corte" value={ DateMethods.dateTimeLarge($AccountStore.expired) } />
        </div>
    </div>
    {#if total}
        <hr>
        <div class="columns">
            <div class="column">
                <Value label="Envíos" value={ NumeralMethods.cash(total.shipmentsTotal) } />
            </div>
            <div class="column">
                <Value label="Envíos cancelados" value={ NumeralMethods.cash(total.shipmentsCanceledTotal) } />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Value label="Cargos" value={ NumeralMethods.cash(total.chargesTotal) } />
            </div>
            <div class="column">
                <Value label="Reembolsos" value={ NumeralMethods.cash(total.refundsTotal) } />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <Value label="Total" value={ NumeralMethods.cash(total.amountTotal) } />
            </div>
        </div>
    {/if}
{/if}